export default {
  DepartmentSelected: new Event('department-selected'),
  QueryParamsHandled: new Event('query-params-handled'),
  VehicleTypeSelected: new Event('vehicle-type-selected'),
  MapInView: new Event('map-in-view'),

  FilterSelected(filter) {
    return new CustomEvent('filter-selected', {
      detail: filter,
    });
  },

  LocationSelected(locationCard) {
    return new CustomEvent('location-selected', {
      detail: locationCard,
    });
  },

  FilterCleared(filter) {
    return new CustomEvent('filter-cleared', {
      detail: filter,
    });
  },
};
